export const ResolveStrategy = Symbol('ResolveStrategy');
